import { FeatureCollection } from "geojson";
import { LifeCycleStage } from "./LifeCycleStage";
import { Score } from "@keita/lanepatrol-sdk";
import { PhotoSource } from "./CraNode";

export interface CraWay {
  id: string;
  surveyId: string;
  name: string;
  uploadFinished: boolean;
  photoSource: PhotoSource;
  lifeCycleStage: LifeCycleStage;
  geoJson: FeatureCollection | null;
  score: Score | null;
  stats: CraWayStats | null;
  permissions: CraWayPermissions;
  description: string | null;
  plannedTrajectory: FeatureCollection | null;
  plannedDistance: number;
  dateTime: string;
  createdAt: string;
}

export interface CraWayStats {
  nNodes: number;
  nNodesCoded: number;
  nActiveComments: number | null;
  totalDistance: number;
}

export interface DeviceOutputLinksResponse {
  outputs: string;
  pictures: string;
}

export interface GpxUploadLinksResponse {
  gpx: string;
  pictures: string;
}

export interface UploadLinksRequest {
  inputType: UploadInputType;
}

export enum UploadInputType {
  DeviceOutput = "DeviceOutput",
  Gpx = "Gpx",
}

export interface CreateCraWay {
  surveyId: string;
  name: string;
}

export interface UpdateCraWay {
  name: string;
  description: string;
  plannedTrajectory: FeatureCollection | null;
  plannedDistance: number;
}

export interface CraWayPermissions {
  canRead: boolean;
  canCreate: boolean;
  canUpdate: boolean;
  canDelete: boolean;
  canCode: boolean;
  canComment: boolean;
  canReview: boolean;
  canManage: boolean;
  canUpdateLifeCycleStage: boolean;
  canRevertLifeCycleStage: boolean;
}
